import { render, staticRenderFns } from "./SanitasFormSearch.vue?vue&type=template&id=05899052&"
import script from "./SanitasFormSearch.vue?vue&type=script&lang=js&"
export * from "./SanitasFormSearch.vue?vue&type=script&lang=js&"
import style0 from "./SanitasFormSearch.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports